// Module
var code = "<iframe loading=\"lazy\" height=\"500\" frameborder=\"0\" src=\"https://jabra.vntana.com/v5/src/index.html\" alt=\"{{productName}}\" title=\"{{productName}}\"></iframe> ";
// Exports
module.exports = code;